import api from "../../Environment";
import configuration from "react-global-configuration";

/**
 * A-009A.3 — Community Navigation API.
 * React consumes only communityNavigationPayload / communityPagePayload.
 */

function settingsFallback() {
  try {
    const fromConfig = configuration.get("configData.community_navigation");
    if (fromConfig && typeof fromConfig === "object") {
      return fromConfig;
    }
  } catch (e) {
    /* ignore */
  }
  return { label: "Community", visible: false, pages: [] };
}

export async function fetchCommunityNavigation() {
  try {
    const response = await api.postMethod("community-navigation", {});
    const body = response && response.data;
    if (body && body.success === true && body.data) {
      return body.data;
    }
  } catch (e) {
    /* fall through to settings */
  }
  return settingsFallback();
}

export async function fetchCommunityPage(slug) {
  const response = await api.postMethod("community/page", { slug });
  const body = response && response.data;
  if (!body || body.success === false) {
    throw new Error(
      (body && (body.error_message || body.error_messages)) ||
        "Unable to load community page"
    );
  }
  return body.data || {};
}

/**
 * Resolve pages list from a navigation payload (API or settings).
 * Hides unfinished Community destinations (Events / Groups) without deleting them.
 */
const HIDDEN_COMMUNITY_SLUGS = new Set(["events", "groups"]);
const HIDDEN_COMMUNITY_FEATURE_TYPES = new Set(["events", "groups"]);

export function communityPagesFromPayload(payload) {
  if (!payload || typeof payload !== "object") {
    return [];
  }
  const pages = payload.pages;
  if (!Array.isArray(pages)) {
    return [];
  }
  return pages.filter((page) => {
    if (!page) return false;
    const slug = String(page.slug || "")
      .trim()
      .toLowerCase();
    const featureType = String(page.feature_type || "")
      .trim()
      .toLowerCase();
    if (HIDDEN_COMMUNITY_SLUGS.has(slug)) return false;
    if (HIDDEN_COMMUNITY_FEATURE_TYPES.has(featureType)) return false;
    return true;
  });
}

export function isCommunityNavVisible(payload) {
  if (!payload || typeof payload !== "object") {
    return false;
  }
  if (payload.visible === false) {
    return false;
  }
  return communityPagesFromPayload(payload).length > 0;
}
